import Common from '../../../Common';
import Tts from './soundfile/Tts';

interface Body {
	name?: string
	description?: string
	passcode?: string
	sound?: string
}

const Soundfile = class extends Common {
	tts: InstanceType<typeof Tts>;

	constructor(headers: ApiHeaders) {
		super(headers)

		this.tts = new Tts(headers);
	}

	browse = (userId: id) =>
		this.get(`/user/${userId}/profile/soundfile`)

	read = (userId: id, soundfileId: id) =>
		this.get(`/user/${userId}/profile/soundfile/${soundfileId}`)

	create = (userId: id, body: Body | FormData) =>
		this.post(`/user/${userId}/profile/soundfile`, body)

	update = (userId: id, soundfileId: id, body: Body | FormData) =>
		this.post(`/user/${userId}/profile/soundfile/${soundfileId}`, body)

	delete = (userId: id, soundfileId: id) =>
		this.doDelete(`/user/${userId}/profile/soundfile/${soundfileId}`)

	inUse = (userId: id, soundfileId: id) =>
		this.get(`/user/${userId}/profile/soundfile/${soundfileId}/inuse`)

	download = (userId: id, soundfileId: id, downloadType: SoundfileDownloadType = 'mp3'): CustomResponse<Blob> =>
		this.get(`/user/${userId}/profile/soundfile/${soundfileId}/${downloadType}`, {}, { responseType: 'blob' });
}

export default Soundfile
